import * as React from 'react';
import { useState } from 'react';
import Button from '../../../../../common/form/Button';
import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

interface Props {
    onCodeAdd: (newBackup: string, name: string) => void;
}

const NewManualAccessRow = (props: Props) => {
    const [newCode, setNewCode] = useState('');
    return (
        <Row className="code-row">
            <Col md={{ size: 8, offset: 1 }}>
                <input
                    className="form-control"
                    value={newCode}
                    placeholder="New Code..."
                    onChange={changeEvent => setNewCode(changeEvent.target.value)}
                />
            </Col>
            <Col md={3}>
                <Button
                    text="Add"
                    onClick={() => props.onCodeAdd(newCode, '')}
                    suppressBottomMargin={true}
                />
            </Col>
        </Row>
    );
};

export default NewManualAccessRow;



// WEBPACK FOOTER //
// ./src/components/pages/admin/editProperty/integrationControls/manualAccessControls/NewManualAccessRow.tsx